var ArgosVocab = {
  BRAND_NAME: 'Argos',
  ADD_TO_TROLLEY: 'Add to trolley',
  ITEM_CONTAINER: 'trolley',
  CREDIT_URL: '/help/credit-offers'
};
export default ArgosVocab;